import './styles/main.scss';
import ComponentFactory from '@core/factories/ComponentFactory';
import AbstractMain from '@core/abstracts/AbstractMain';
import { Components } from './components';
import Rellax from 'rellax';
import { URL } from '@utilities';
import jQuery from 'jquery';

class Main extends AbstractMain {
  _anim = [
    '-',
    '-‌‌ -',
    '‌‌ -‌‌ -',
    '‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '-‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '-‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '-‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '-‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -‌‌ ',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ -',
    '‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ‌‌ ',
  ];
  _currentFrame = 0;

  constructor() {
    super();

    this._init();
  }

  _init() {
    new ComponentFactory(Components);

    if (document.querySelectorAll('[data-rellax-speed]').length) {
      new Rellax('[data-rellax-speed]', {});
    }

    this._animateTitle();

    // jQuery(document).on('gform_after_submission', function (event, formId) {
    //   console.log('adsad');
    //   // code to be trigger when confirmation page is loaded
    //   console.log(formId);
    // });
  }

  _animateTitle() {
    setInterval(() => {
      document.title = this._anim[this._currentFrame];
      this._currentFrame =
        this._currentFrame == this._anim.length - 1
          ? 1
          : this._currentFrame + 1;
    }, 100);
  }
}

new Main();
